import { observer } from "mobx-react";
import { RadioButton } from "../../../../components/inputs/radio-button/radio-button";
import LocaleStore from "../../stores/locale-store";
import "./select-default-locale.scss"

interface ISelectDefaultLocaleProps {
    locale: LocaleStore;
}

const SelectDefaultLanguage: React.FC<ISelectDefaultLocaleProps> = observer(({locale}) => {
    
    return(
        <div className="select-default-locale">
            <RadioButton
                name={locale.localeName}
                checked={locale.is_default}
                value={locale.localeName}
                onChange={() => locale.setDefault()}
                disabled={!locale.enabled}
            />
        </div>
    )
})

export default SelectDefaultLanguage;